import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-scroll-outer" }
const _hoisted_7 = { class: "table-scroll-mobile" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "text-info"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "text-nowrap" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { style: {"word-wrap":"break-word","width":"50%"} }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_30 = { class: "mb-0 text-paragraph" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "mt-15 mt-md-0" }
const _hoisted_35 = { class: "pagination mb-0" }
const _hoisted_36 = {
  key: 0,
  class: "page-item"
}
const _hoisted_37 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 2,
  class: "page-item disabled"
}
const _hoisted_40 = {
  key: 3,
  class: "page-item"
}
const _hoisted_41 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_43 = { class: "modal-content p-15 p-md-40" }
const _hoisted_44 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/add-colis",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Nouveau Colis ", -1),
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
            ])),
            _: 1,
            __: [5]
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              type: "text",
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Chercher"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " Code d'envoi "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Dernière mise à jour "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Destinataire "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Commentaire "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Status "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Ville "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Prix "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                  })
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (row.replace === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_11, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                            ]))
                          : (row.partial === 1)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                                _createTextVNode(_toDisplayString(row.code) + " ", 1),
                                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                              ]))
                            : (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(row.code), 1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.getDate(row.updated_at)), 1),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, [
                        _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(row.note), 1)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", {
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({ '--dynamic-bg': _ctx.getBadgeConfig(row).color })
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).text) + " ", 1),
                        (_ctx.getBadgeConfig(row).date)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).date), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.getBadgeConfig(row).comment)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).comment), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 4)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("b", null, _toDisplayString(row.city_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("b", null, _toDisplayString(row.price), 1),
                      _cache[15] || (_cache[15] = _createTextVNode("Dhs", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(row.product_nature), 1)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[20] || (_cache[20] = _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_24, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetails(row))
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ", -1)
                            ]), 8, _hoisted_25)
                          ]),
                          (row.status === 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.Destroy_Coli(row))
                                }, _cache[18] || (_cache[18] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Supprimer ", -1)
                                ]), 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true),
                          (row.status == 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                _createVNode(_component_router_link, {
                                  to: `/edit-colis/${row.id}/${row.code}`,
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);"
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Modifier ", -1)
                                  ])),
                                  _: 2,
                                  __: [19]
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, [
            _cache[22] || (_cache[22] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_31, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[23] || (_cache[23] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_32, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[24] || (_cache[24] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.filter.total), 1),
            _cache[25] || (_cache[25] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_34, [
            _createElementVNode("ul", _hoisted_35, [
              (_ctx.displayedPages[0] > 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(1)))
                    }, "1")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.displayedPages[0] > 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_37, _cache[26] || (_cache[26] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_38)
                ]))
              }), 128)),
              (
                _ctx.displayedPages[_ctx.displayedPages.length - 1] < _ctx.filter.last_page - 1
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_39, _cache[27] || (_cache[27] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (
                _ctx.displayedPages[_ctx.displayedPages.length - 1] < _ctx.filter.last_page
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.filter.last_page)))
                    }, _toDisplayString(_ctx.filter.last_page), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpen
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}